


































































import { Mixins, Component, Prop, Watch } from 'vue-property-decorator';
import { AxPage } from '@/mixins';

import * as I from '@/interfaces';

@Component
export default class AxRelayPortDialog extends Mixins(AxPage) {
  on = true;
  search = '';

  width = 400;
  height = 300;

  @Prop({ default: () => new I.DataParam() })
  param!: I.DataParam;

  @Prop({ type: String, default: '코드 선택' })
  title!: string;

  @Prop({ type: Boolean, default: false })
  single!: boolean;

  @Prop({ type: String, default: 'code' })
  itemKey!: string;

  @Prop({ type: Boolean, default: true })
  showSelect!: boolean;

  @Watch('on')
  onSwitchChanged() {
    this.$emit('changed', this.on);
  }

  onDialogChanged() {
    this.param.callback();
  }

  onDialogRowClicked(item: never) {
    if (this.single) {
      if (this.param.selected[0] === item) {
        this.param.selected = [];
      } else {
        this.param.selected = [item];
      }
      return;
    }

    type UnknownMap = { [key: string]: unknown };

    const idx = (this.param.selected as UnknownMap[]).findIndex(
      x => x[this.itemKey] === (item as UnknownMap)[this.itemKey]
    );
    if (idx > -1) {
      this.param.selected.splice(idx, 1);
    } else {
      this.param.selected.push(item);
    }
  }

  onClearClicked() {
    this.param.selected = [];
    this.param.callback();
  }
}
